import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import { GET_DASHBOARD } from "./graphql";

const getDashboard = async (variables) => {
  const response = await client.query({
    query: GET_DASHBOARD,
    fetchPolicy: "network-only",
    variables,
  });

  const results = await getGraphqlResult(response, "getDashboard");
  return results;
};

export { getDashboard };
